import { render, staticRenderFns } from "./annotated_component.vue?vue&type=template&id=68fc2914"
import script from "./annotated_component.vue?vue&type=script&lang=js"
export * from "./annotated_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports